// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.payPage {
  background: var(--gris-foncer);
  min-height: 100vh;
  padding: 12px 0 40px;
  font-family: "Lato", sans-serif;
}

/* En-tête */
.payHeaderBar {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
  margin: 18px 0 16px;
}

.payTitle {
  font-size: 22px;
  font-weight: 800;
  color: var(--couleur-dark);
  margin: 0 0 4px;
}

.paySubtitle {
  font-size: 13px;
  color: var(--gris-terciaire);
  margin: 0;
}

.payStats {
  display: flex;
  gap: 24px;
}

.payStat {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}

.payStatValue {
  font-family: Menlo, Consolas, monospace;
  font-size: 16px;
  font-weight: 700;
  color: var(--couleur-principale);
}

.payStatLabel {
  font-size: 11px;
  color: var(--gris-terciaire);
}

/* Filtres */
.payFilters {
  display: flex;
  gap: 8px;
  overflow-x: auto;
  padding-bottom: 4px;
  margin-bottom: 20px;
}

.payChip {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 14px;
  border-radius: 999px;
  border: 1px solid var(--gris-secondaire-2);
  background: var(--white-principale);
  color: var(--couleur-dark-primary);
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
  transition: background .15s ease, color .15s ease, border-color .15s ease;
}

.payChip:hover {
  border-color: var(--couleur-principale);
}

.payChip.active {
  background: var(--couleur-principale);
  border-color: var(--couleur-principale);
  color: var(--white-principale);
}

.payChipCount {
  font-size: 11px;
  opacity: .75;
}

/* Grille de tickets */
.payGridTickets {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 16px;
}

.ticket {
  position: relative;
  background: var(--white-principale);
  border-radius: 16px;
  box-shadow: 0 1px 3px var(--gris-shadow);
  cursor: pointer;
  transition: transform .15s ease, box-shadow .15s ease;
  overflow: visible;
}

.ticket:hover {
  transform: translateY(-3px);
  box-shadow: 0 10px 24px rgba(0, 0, 0, .1);
}

.ticketTop {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 16px 0;
}

.ticketMethod {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  font-weight: 700;
  color: var(--couleur-principale);
}

.ticketTime {
  font-size: 11px;
  color: var(--gris-terciaire);
}

.ticketBody {
  padding: 8px 16px 16px;
}

.ticketArticle {
  font-size: 14px;
  font-weight: 800;
  color: var(--couleur-dark);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.ticketType {
  font-size: 12px;
  color: var(--gris-terciaire);
  margin-top: 2px;
}

.ticketDiscount {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  margin-top: 8px;
  padding: 4px 9px;
  border-radius: 999px;
  background: #e7f7ee;
  color: #116b34;
  font-size: 11px;
  font-weight: 800;
}

/* Perforation façon ticket */
.ticketPerf {
  position: relative;
  height: 0;
  border-top: 2px dashed var(--gris-secondaire-2);
  margin: 0 0;
}

.ticketPerf::before,
.ticketPerf::after {
  content: "";
  position: absolute;
  top: -10px;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: var(--gris-foncer);
}

.ticketPerf::before {
  left: -10px;
}

.ticketPerf::after {
  right: -10px;
}

.ticketFooter {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 16px;
}

.ticketAmount {
  font-family: Menlo, Consolas, monospace;
  font-size: 16px;
  font-weight: 700;
  color: var(--couleur-dark);
}

.ticketStatus {
  font-size: 12px;
  font-weight: 700;
}

.ticketStatus.paid {
  color: #116b34;
}

.ticketStatus.pending {
  color: #8a4b00;
}

.ticketStatus.failed {
  color: #8f0f22;
}

.ticketStatus.free {
  color: #2b3b9a;
}

.ticketStatus.unknown {
  color: var(--gris-terciaire);
}

.ticket.status-failed .ticketMethod {
  color: var(--couleur-secondaire);
}

.ticket.status-free .ticketMethod {
  color: var(--vert-principale);
}

/* Etats */
.payLoading {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 40px 0;
  color: var(--gris-terciaire);
  font-size: 13px;
  justify-content: center;
}

.paySpinner {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  border: 2px solid var(--gris-secondaire-2);
  border-top-color: var(--couleur-principale);
  animation: paySpin .7s linear infinite;
}

@keyframes paySpin {
  to {
    transform: rotate(360deg);
  }
}

.payEmpty {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 50px 0;
  color: var(--gris-terciaire);
  font-size: 13px;
  text-align: center;
}

.payEmpty i {
  font-size: 30px;
  opacity: .5;
}

/* Actions */
.payActions {
  margin-top: 24px;
  display: flex;
  justify-content: center;
}

.payBtn {
  width: 100%;
  max-width: 320px;
  height: 42px;
  border: none;
  border-radius: 999px;
  background: var(--couleur-principale);
  color: var(--white-principale);
  font-weight: 800;
  font-size: 13px;
  cursor: pointer;
  transition: background .15s ease;
}

.payBtn:hover {
  background: var(--couleur-secondaire);
}

/* Modal (portail vers document.body) */
.payModalOverlay {
  position: fixed;
  inset: 0;
  background: rgba(2, 6, 23, .55);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 18px;
  z-index: 2147483000;
}

.payModalSheet {
  position: relative;
  width: 100%;
  max-width: 440px;
  max-height: 88vh;
  overflow-y: auto;
  background: var(--white-principale);
  border-radius: 18px;
  box-shadow: 0 24px 70px rgba(0, 0, 0, .35);
}

.payModalClose {
  position: absolute;
  top: 14px;
  right: 14px;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border: none;
  background: var(--gris-foncer);
  color: var(--couleur-dark);
  cursor: pointer;
  z-index: 1;
}

.payModalHead {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 22px 50px 14px 20px;
}

.payMethodBadge {
  flex: 0 0 auto;
  width: 44px;
  height: 44px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  background: #eef2ff;
  color: var(--couleur-principale);
}

.payMethodBadge.failed {
  background: #fde8ea;
  color: var(--couleur-secondaire);
}

.payMethodBadge.free {
  background: #ecfeff;
  color: var(--vert-principale);
}

.payModalArticle {
  font-size: 14px;
  font-weight: 800;
  color: var(--couleur-dark);
}

.payModalWhen {
  font-size: 12px;
  color: var(--gris-terciaire);
  margin-top: 2px;
}

.payStatusPill {
  margin-left: auto;
  font-size: 11px;
  font-weight: 800;
  padding: 5px 10px;
  border-radius: 999px;
  flex: 0 0 auto;
}

.payStatusPill.paid {
  background: #e7f7ee;
  color: #116b34;
}

.payStatusPill.pending {
  background: #fff4e5;
  color: #8a4b00;
}

.payStatusPill.failed {
  background: #fde8ea;
  color: #8f0f22;
}

.payStatusPill.free {
  background: #eef2ff;
  color: #2b3b9a;
}

.payStatusPill.unknown {
  background: #f8f9fa;
  color: var(--gris-terciaire);
}

.payModalPerf {
  border-top: 2px dashed var(--gris-secondaire-2);
  margin: 0 20px;
}

.payModalBody {
  padding: 18px 20px 22px;
}

.payPriceBlock {
  border: 1px solid var(--gris-secondaire-2);
  border-radius: 14px;
  padding: 14px;
  margin-bottom: 18px;
}

.payPriceLine {
  display: flex;
  justify-content: space-between;
  font-size: 13px;
  color: var(--gris-terciaire);
  padding: 4px 0;
}

.payPriceLine .strike {
  text-decoration: line-through;
  font-family: Menlo, Consolas, monospace;
}

.payPriceLine.discount {
  color: var(--vert-principale);
  font-weight: 700;
}

.payPriceLine.discount span:last-child {
  font-family: Menlo, Consolas, monospace;
}

.payCouponChip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin: 6px 0 2px;
  padding: 5px 10px;
  border-radius: 999px;
  background: #eef2ff;
  color: var(--couleur-principale);
  font-size: 11px;
  font-weight: 800;
}

.payPriceLine.total {
  margin-top: 6px;
  padding-top: 10px;
  border-top: 1px solid var(--gris-secondaire-2);
  font-size: 19px;
  font-weight: 800;
  color: var(--couleur-dark);
}

.payPriceLine.total span:last-child {
  font-family: Menlo, Consolas, monospace;
}

.payInfoGrid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
  margin-bottom: 18px;
}

.payInfo {
  border: 1px solid var(--gris-secondaire-2);
  border-radius: 12px;
  padding: 10px;
  background: var(--gris-foncer);
}

.payInfoLabel {
  font-size: 11px;
  color: var(--gris-terciaire);
  font-weight: 700;
  margin-bottom: 4px;
}

.payInfoValue {
  font-size: 12px;
  color: var(--couleur-dark);
  font-weight: 700;
  word-break: break-word;
}

.payInfoValue.mono {
  font-family: Menlo, Consolas, monospace;
  font-weight: 400;
  font-size: 11px;
}

.payRefs {
  border-top: 1px solid var(--gris-secondaire-2);
  padding-top: 14px;
}

.payRefsTitle {
  font-size: 12px;
  font-weight: 800;
  color: var(--couleur-dark);
  margin-bottom: 10px;
}

.payRefRow {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 8px 0;
}

.payCopyBtn {
  border: 1px solid var(--gris-secondaire-2);
  background: var(--white-principale);
  width: 30px;
  height: 30px;
  border-radius: 8px;
  cursor: pointer;
  color: var(--gris-terciaire);
  flex: 0 0 auto;
}

.payCopyBtn:hover {
  border-color: var(--couleur-principale);
  color: var(--couleur-principale);
}

/* Modal iframe de paiement (conservé, inchangé) */
.orange_modal_overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.orange_modal_content {
  background: #fff;
  border-radius: 8px;
  width: 90%;
  max-width: 480px;
  height: 85vh;
  position: relative;
  display: flex;
  flex-direction: column;
}

.orange_modal_close {
  position: absolute;
  top: 8px;
  right: 12px;
  font-size: 24px;
  background: none;
  border: none;
  cursor: pointer;
  z-index: 1;
}

.orange_modal_status {
  text-align: center;
  padding: 8px;
  margin: 0;
  font-size: 14px;
  color: #555;
}

.orange_modal_iframe {
  flex: 1 1;
  width: 100%;
  border: none;
}

/* Responsive */
@media (max-width: 720px) {
  .payHeaderBar {
    flex-direction: column;
  }

  .payStats {
    width: 100%;
    justify-content: space-between;
  }

  .payGridTickets {
    grid-template-columns: 1fr;
  }

  .payInfoGrid {
    grid-template-columns: 1fr;
  }
}`, "",{"version":3,"sources":["webpack://./src/assets/css/paiements/MesPaiementsPage.css"],"names":[],"mappings":"AAAA;EACE,8BAA8B;EAC9B,iBAAiB;EACjB,oBAAoB;EACpB,+BAA+B;AACjC;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,4BAA4B;AAC9B;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,QAAQ;EACR,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,oBAAoB;EACpB,0CAA0C;EAC1C,mCAAmC;EACnC,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yEAAyE;AAC3E;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,qCAAqC;EACrC,uCAAuC;EACvC,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,mCAAmC;EACnC,mBAAmB;EACnB,wCAAwC;EACxC,eAAe;EACf,qDAAqD;EACrD,iBAAiB;AACnB;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA,6BAA6B;AAC7B;EACE,kBAAkB;EAClB,SAAS;EACT,+CAA+C;EAC/C,WAAW;AACb;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA,UAAU;AACV;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,4BAA4B;EAC5B,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,0CAA0C;EAC1C,2CAA2C;EAC3C,sCAAsC;AACxC;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,4BAA4B;EAC5B,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA,YAAY;AACZ;EACE,gBAAgB;EAChB,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,oBAAoB;EACpB,qCAAqC;EACrC,8BAA8B;EAC9B,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,qCAAqC;AACvC;;AAEA,uCAAuC;AACvC;EACE,eAAe;EACf,QAAQ;EACR,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,mCAAmC;EACnC,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,8BAA8B;EAC9B,0BAA0B;EAC1B,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,4BAA4B;AAC9B;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,+CAA+C;EAC/C,cAAc;AAChB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,0CAA0C;EAC1C,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,eAAe;EACf,4BAA4B;EAC5B,cAAc;AAChB;;AAEA;EACE,6BAA6B;EAC7B,uCAAuC;AACzC;;AAEA;EACE,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,gCAAgC;EAChC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,8CAA8C;EAC9C,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,0CAA0C;EAC1C,mBAAmB;EACnB,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,uCAAuC;EACvC,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,8CAA8C;EAC9C,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,0CAA0C;EAC1C,mCAAmC;EACnC,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,4BAA4B;EAC5B,cAAc;AAChB;;AAEA;EACE,uCAAuC;EACvC,gCAAgC;AAClC;;AAEA,kDAAkD;AAClD;EACE,eAAe;EACf,QAAQ;EACR,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,eAAe;EACf,WAAW;AACb;;AAEA;EACE,SAAO;EACP,WAAW;EACX,YAAY;AACd;;AAEA,eAAe;AACf;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,8BAA8B;EAChC;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;AACF","sourcesContent":[".payPage {\n  background: var(--gris-foncer);\n  min-height: 100vh;\n  padding: 12px 0 40px;\n  font-family: \"Lato\", sans-serif;\n}\n\n/* En-tête */\n.payHeaderBar {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 16px;\n  flex-wrap: wrap;\n  margin: 18px 0 16px;\n}\n\n.payTitle {\n  font-size: 22px;\n  font-weight: 800;\n  color: var(--couleur-dark);\n  margin: 0 0 4px;\n}\n\n.paySubtitle {\n  font-size: 13px;\n  color: var(--gris-terciaire);\n  margin: 0;\n}\n\n.payStats {\n  display: flex;\n  gap: 24px;\n}\n\n.payStat {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n}\n\n.payStatValue {\n  font-family: Menlo, Consolas, monospace;\n  font-size: 16px;\n  font-weight: 700;\n  color: var(--couleur-principale);\n}\n\n.payStatLabel {\n  font-size: 11px;\n  color: var(--gris-terciaire);\n}\n\n/* Filtres */\n.payFilters {\n  display: flex;\n  gap: 8px;\n  overflow-x: auto;\n  padding-bottom: 4px;\n  margin-bottom: 20px;\n}\n\n.payChip {\n  flex: 0 0 auto;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 8px 14px;\n  border-radius: 999px;\n  border: 1px solid var(--gris-secondaire-2);\n  background: var(--white-principale);\n  color: var(--couleur-dark-primary);\n  font-size: 13px;\n  font-weight: 700;\n  cursor: pointer;\n  transition: background .15s ease, color .15s ease, border-color .15s ease;\n}\n\n.payChip:hover {\n  border-color: var(--couleur-principale);\n}\n\n.payChip.active {\n  background: var(--couleur-principale);\n  border-color: var(--couleur-principale);\n  color: var(--white-principale);\n}\n\n.payChipCount {\n  font-size: 11px;\n  opacity: .75;\n}\n\n/* Grille de tickets */\n.payGridTickets {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));\n  gap: 16px;\n}\n\n.ticket {\n  position: relative;\n  background: var(--white-principale);\n  border-radius: 16px;\n  box-shadow: 0 1px 3px var(--gris-shadow);\n  cursor: pointer;\n  transition: transform .15s ease, box-shadow .15s ease;\n  overflow: visible;\n}\n\n.ticket:hover {\n  transform: translateY(-3px);\n  box-shadow: 0 10px 24px rgba(0, 0, 0, .1);\n}\n\n.ticketTop {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 14px 16px 0;\n}\n\n.ticketMethod {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 12px;\n  font-weight: 700;\n  color: var(--couleur-principale);\n}\n\n.ticketTime {\n  font-size: 11px;\n  color: var(--gris-terciaire);\n}\n\n.ticketBody {\n  padding: 8px 16px 16px;\n}\n\n.ticketArticle {\n  font-size: 14px;\n  font-weight: 800;\n  color: var(--couleur-dark);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.ticketType {\n  font-size: 12px;\n  color: var(--gris-terciaire);\n  margin-top: 2px;\n}\n\n.ticketDiscount {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  margin-top: 8px;\n  padding: 4px 9px;\n  border-radius: 999px;\n  background: #e7f7ee;\n  color: #116b34;\n  font-size: 11px;\n  font-weight: 800;\n}\n\n/* Perforation façon ticket */\n.ticketPerf {\n  position: relative;\n  height: 0;\n  border-top: 2px dashed var(--gris-secondaire-2);\n  margin: 0 0;\n}\n\n.ticketPerf::before,\n.ticketPerf::after {\n  content: \"\";\n  position: absolute;\n  top: -10px;\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  background: var(--gris-foncer);\n}\n\n.ticketPerf::before {\n  left: -10px;\n}\n\n.ticketPerf::after {\n  right: -10px;\n}\n\n.ticketFooter {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 14px 16px;\n}\n\n.ticketAmount {\n  font-family: Menlo, Consolas, monospace;\n  font-size: 16px;\n  font-weight: 700;\n  color: var(--couleur-dark);\n}\n\n.ticketStatus {\n  font-size: 12px;\n  font-weight: 700;\n}\n\n.ticketStatus.paid {\n  color: #116b34;\n}\n\n.ticketStatus.pending {\n  color: #8a4b00;\n}\n\n.ticketStatus.failed {\n  color: #8f0f22;\n}\n\n.ticketStatus.free {\n  color: #2b3b9a;\n}\n\n.ticketStatus.unknown {\n  color: var(--gris-terciaire);\n}\n\n.ticket.status-failed .ticketMethod {\n  color: var(--couleur-secondaire);\n}\n\n.ticket.status-free .ticketMethod {\n  color: var(--vert-principale);\n}\n\n/* Etats */\n.payLoading {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 40px 0;\n  color: var(--gris-terciaire);\n  font-size: 13px;\n  justify-content: center;\n}\n\n.paySpinner {\n  width: 16px;\n  height: 16px;\n  border-radius: 50%;\n  border: 2px solid var(--gris-secondaire-2);\n  border-top-color: var(--couleur-principale);\n  animation: paySpin .7s linear infinite;\n}\n\n@keyframes paySpin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.payEmpty {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 8px;\n  padding: 50px 0;\n  color: var(--gris-terciaire);\n  font-size: 13px;\n  text-align: center;\n}\n\n.payEmpty i {\n  font-size: 30px;\n  opacity: .5;\n}\n\n/* Actions */\n.payActions {\n  margin-top: 24px;\n  display: flex;\n  justify-content: center;\n}\n\n.payBtn {\n  width: 100%;\n  max-width: 320px;\n  height: 42px;\n  border: none;\n  border-radius: 999px;\n  background: var(--couleur-principale);\n  color: var(--white-principale);\n  font-weight: 800;\n  font-size: 13px;\n  cursor: pointer;\n  transition: background .15s ease;\n}\n\n.payBtn:hover {\n  background: var(--couleur-secondaire);\n}\n\n/* Modal (portail vers document.body) */\n.payModalOverlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(2, 6, 23, .55);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 18px;\n  z-index: 2147483000;\n}\n\n.payModalSheet {\n  position: relative;\n  width: 100%;\n  max-width: 440px;\n  max-height: 88vh;\n  overflow-y: auto;\n  background: var(--white-principale);\n  border-radius: 18px;\n  box-shadow: 0 24px 70px rgba(0, 0, 0, .35);\n}\n\n.payModalClose {\n  position: absolute;\n  top: 14px;\n  right: 14px;\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  border: none;\n  background: var(--gris-foncer);\n  color: var(--couleur-dark);\n  cursor: pointer;\n  z-index: 1;\n}\n\n.payModalHead {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 22px 50px 14px 20px;\n}\n\n.payMethodBadge {\n  flex: 0 0 auto;\n  width: 44px;\n  height: 44px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 18px;\n  background: #eef2ff;\n  color: var(--couleur-principale);\n}\n\n.payMethodBadge.failed {\n  background: #fde8ea;\n  color: var(--couleur-secondaire);\n}\n\n.payMethodBadge.free {\n  background: #ecfeff;\n  color: var(--vert-principale);\n}\n\n.payModalArticle {\n  font-size: 14px;\n  font-weight: 800;\n  color: var(--couleur-dark);\n}\n\n.payModalWhen {\n  font-size: 12px;\n  color: var(--gris-terciaire);\n  margin-top: 2px;\n}\n\n.payStatusPill {\n  margin-left: auto;\n  font-size: 11px;\n  font-weight: 800;\n  padding: 5px 10px;\n  border-radius: 999px;\n  flex: 0 0 auto;\n}\n\n.payStatusPill.paid {\n  background: #e7f7ee;\n  color: #116b34;\n}\n\n.payStatusPill.pending {\n  background: #fff4e5;\n  color: #8a4b00;\n}\n\n.payStatusPill.failed {\n  background: #fde8ea;\n  color: #8f0f22;\n}\n\n.payStatusPill.free {\n  background: #eef2ff;\n  color: #2b3b9a;\n}\n\n.payStatusPill.unknown {\n  background: #f8f9fa;\n  color: var(--gris-terciaire);\n}\n\n.payModalPerf {\n  border-top: 2px dashed var(--gris-secondaire-2);\n  margin: 0 20px;\n}\n\n.payModalBody {\n  padding: 18px 20px 22px;\n}\n\n.payPriceBlock {\n  border: 1px solid var(--gris-secondaire-2);\n  border-radius: 14px;\n  padding: 14px;\n  margin-bottom: 18px;\n}\n\n.payPriceLine {\n  display: flex;\n  justify-content: space-between;\n  font-size: 13px;\n  color: var(--gris-terciaire);\n  padding: 4px 0;\n}\n\n.payPriceLine .strike {\n  text-decoration: line-through;\n  font-family: Menlo, Consolas, monospace;\n}\n\n.payPriceLine.discount {\n  color: var(--vert-principale);\n  font-weight: 700;\n}\n\n.payPriceLine.discount span:last-child {\n  font-family: Menlo, Consolas, monospace;\n}\n\n.payCouponChip {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  margin: 6px 0 2px;\n  padding: 5px 10px;\n  border-radius: 999px;\n  background: #eef2ff;\n  color: var(--couleur-principale);\n  font-size: 11px;\n  font-weight: 800;\n}\n\n.payPriceLine.total {\n  margin-top: 6px;\n  padding-top: 10px;\n  border-top: 1px solid var(--gris-secondaire-2);\n  font-size: 19px;\n  font-weight: 800;\n  color: var(--couleur-dark);\n}\n\n.payPriceLine.total span:last-child {\n  font-family: Menlo, Consolas, monospace;\n}\n\n.payInfoGrid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 10px;\n  margin-bottom: 18px;\n}\n\n.payInfo {\n  border: 1px solid var(--gris-secondaire-2);\n  border-radius: 12px;\n  padding: 10px;\n  background: var(--gris-foncer);\n}\n\n.payInfoLabel {\n  font-size: 11px;\n  color: var(--gris-terciaire);\n  font-weight: 700;\n  margin-bottom: 4px;\n}\n\n.payInfoValue {\n  font-size: 12px;\n  color: var(--couleur-dark);\n  font-weight: 700;\n  word-break: break-word;\n}\n\n.payInfoValue.mono {\n  font-family: Menlo, Consolas, monospace;\n  font-weight: 400;\n  font-size: 11px;\n}\n\n.payRefs {\n  border-top: 1px solid var(--gris-secondaire-2);\n  padding-top: 14px;\n}\n\n.payRefsTitle {\n  font-size: 12px;\n  font-weight: 800;\n  color: var(--couleur-dark);\n  margin-bottom: 10px;\n}\n\n.payRefRow {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n  padding: 8px 0;\n}\n\n.payCopyBtn {\n  border: 1px solid var(--gris-secondaire-2);\n  background: var(--white-principale);\n  width: 30px;\n  height: 30px;\n  border-radius: 8px;\n  cursor: pointer;\n  color: var(--gris-terciaire);\n  flex: 0 0 auto;\n}\n\n.payCopyBtn:hover {\n  border-color: var(--couleur-principale);\n  color: var(--couleur-principale);\n}\n\n/* Modal iframe de paiement (conservé, inchangé) */\n.orange_modal_overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.6);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 9999;\n}\n\n.orange_modal_content {\n  background: #fff;\n  border-radius: 8px;\n  width: 90%;\n  max-width: 480px;\n  height: 85vh;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n}\n\n.orange_modal_close {\n  position: absolute;\n  top: 8px;\n  right: 12px;\n  font-size: 24px;\n  background: none;\n  border: none;\n  cursor: pointer;\n  z-index: 1;\n}\n\n.orange_modal_status {\n  text-align: center;\n  padding: 8px;\n  margin: 0;\n  font-size: 14px;\n  color: #555;\n}\n\n.orange_modal_iframe {\n  flex: 1;\n  width: 100%;\n  border: none;\n}\n\n/* Responsive */\n@media (max-width: 720px) {\n  .payHeaderBar {\n    flex-direction: column;\n  }\n\n  .payStats {\n    width: 100%;\n    justify-content: space-between;\n  }\n\n  .payGridTickets {\n    grid-template-columns: 1fr;\n  }\n\n  .payInfoGrid {\n    grid-template-columns: 1fr;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
